import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import * as _ from "underscore";
import { UserData } from "../shared/service/UserService";
import { Observable } from "rxjs";
import { CryptoService } from "app/shared/utils/crypto.service";

@Injectable({
  providedIn: "root",
})
export class AdvanceVectoringUserService {
  // ***************SG-7046 start  *******************

  private apiUrl: string;
  private header;
  private headerAppJSON;
  private crypto: CryptoService;

  constructor(private http: HttpClient) {
    this.apiUrl = UserData.backend_url + "/v1";
    this.header = this.getHeader();
    this.headerAppJSON = this.getHeaderAppJSON();
  }

  public getHeader() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: authorizationString,
      }),
    };
    return httpOptions;
  }

  public getHeaderAppJSON() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: authorizationString,
        "Content-Type": "application/json",
      }),
    };
    return httpOptions;
  }
  // *************** SG-4637 start******************
  public getUserMissionData(gameId, day, fromDate, toDate, userName) {
    let url = `/analytics/getUserAnalyticsCompletedPracticeSetDetails?gameId=${gameId}&usageType=${day}&selectedUserName=${userName}`;

    if (day == "range") {
      url = `/analytics/getUserAnalyticsCompletedPracticeSetDetails?gameId=${gameId}&selectedUserName=${userName}&fromDate=${fromDate}&toDate=${toDate}`;
    }
    // *************** SG-4637 end******************

    return this.http.get(this.apiUrl + url, this.header);
  }

  // *************** SG-4637 start******************

  public getUserMissionDataBasicVectoring(gameId, day, fromDate, toDate, userName) {
    let url = `/analytics/getUserAnalyticsCompletedPracticeSetDetails?gameId=${gameId}&usageType=${day}&selectedUserName=${userName}`;

    if (day == "range") {
      url = `/analytics/getUserAnalyticsCompletedPracticeSetDetails?gameId=${gameId}&selectedUserName=${userName}&fromDate=${fromDate}&toDate=${toDate}`;
    }
    // *************** SG-4637 end******************

    return this.http.get(this.apiUrl + url, this.header);
  }

  getGraphDetailsForBasicUsers(gameId, usageType, type, startDate, endDate, userName) {
    let url = "";
    if (type == "month") {
      url = `/analytics/sessionsPlayedMonths?fromDate=${startDate}&gameId=${gameId}&selectedUsageType=${usageType}&userName=${userName}`;
    } else if (type == "day") {
      url = `/analytics/sessionsPlayedUsage?fromDate=${startDate}&gameId=${gameId}&selectedUsageType=${usageType}&userName=${userName}`;
    } else if (type == "year") {
      url = `/analytics/sessionsPlayedYear?fromDate=${startDate}&gameId=${gameId}&selectedUsageType=${usageType}&userName=${userName}`;
    } else if (type == "range") {
      url = `/analytics/sessionsPlayedCustomRange?fromDate=${startDate}&toDate=${endDate}&gameId=${gameId}&selectedUsageType=${usageType}&userName=${userName}`;
    }
    return this.http.get(this.apiUrl + url, this.header);
  }
  // *************** SG-4637 start******************

  downloadGraphdata(usage, day, gameId, dropDownType, userName, fromDate, toDate): Observable<Blob> {
    let url = `/generalAnalytics/recordUsage?analyticsType=${usage}&usageType=${day.toLowerCase()}&gameId=${gameId}&selectedUsageType=${dropDownType}&userName=${userName}`;
    if (day == "range") {
      url = `/generalAnalytics/recordUsage?analyticsType=${usage}&fromDate=${fromDate}&toDate=${toDate}&gameId=${gameId}&selectedUsageType=${dropDownType}&userName=${userName}`;
    }
    return this.http.get(this.apiUrl + url, { responseType: "blob" });
  }
  // *************** SG-4637 end******************

  downloadMissiondata(day, gameId, userName): Observable<Blob> {
    let url = `/analytics/getUserAnalyticsCompletedPracticeSetDetails?gameId=${gameId}&usageType=${day}&selectedUserName=${userName}`;
    return this.http.get(this.apiUrl + url, { responseType: "blob" });
  }
  // ***************SG-7049 start  *******************
  getUserMissionLevelData(day, gameName, userName, fromDate, toDate) {
    let url = `/analytics/advVectoringMissionAnalyticsUsage?${day}=${day}&missionType=${gameName}&selectedUserName=${userName}`;
    if (day == "range") {
      url = `/analytics/advVectoringMissionAnalyticsUsage?fromDate=${fromDate}&toDate=${toDate}&missionType=${gameName}&selectedUserName=${userName}`;
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  downLoadMissionWiseRecords(day, gameName, userName, fromDate, toDate): Observable<Blob> {
    let url = `/analytics/downloadAdvVectoringMissionAnalyticsUsage?${day}=${day}&missionType=${gameName}&selectedUserName=${userName}`;
    if (day == "range") {
      url = `/analytics/downloadAdvVectoringMissionAnalyticsUsage?fromDate=${fromDate}&toDate=${toDate}&missionType=${gameName}&selectedUserName=${userName}`;
    }
    return this.http.get(this.apiUrl + url, { responseType: "blob" });
  }

  getUserwiseAdvanceVectoringGraph(day, gameName, userName, usageType, fromDate, toDate) {
    let url = `/analytics/advVectoringMissionAnalyticsUsageGraph?${day}=${day}&missionType=${gameName}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    if (day == "range") {
      url = `/analytics/advVectoringMissionAnalyticsUsageGraph?fromDate=${fromDate}&toDate=${toDate}&missionType=${gameName}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  downLoadMissionWiseGraph(day, gameName, userName, usageType, fromDate, toDate): Observable<Blob> {
    let url = `/analytics/downloadAdvVectoringMissionAnalyticsUsageGraph?${day}=${day}&missionType=${gameName}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    if (day == "range") {
      url = `/analytics/downloadAdvVectoringMissionAnalyticsUsageGraph?fromDate=${fromDate}&toDate=${toDate}&missionType=${gameName}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    }
    return this.http.get(this.apiUrl + url, { responseType: "blob" });
  }
  // ***************SG-7049 end  *******************

  // ***************SG-7145 start  *******************
  getUserDetails(name, gameId) {
    let url = "/analytics/UserAnalyticsDetails/" + name + "?gameId=" + gameId;
    return this.http.get(this.apiUrl + url, this.header);
  }

  getBasicLessonWiseData(day, gameType, userName, fromDate, toDate) {
    let url = `/analytics/basicVectoringLessonAnalyticsUsage?${day}=${day}&lessonType=${gameType}&selectedUserName=${userName}`;
    if (day == "range") {
      url = `/analytics/basicVectoringLessonAnalyticsUsage?selectedUserName=${userName}&fromDate=${fromDate}&toDate=${toDate}&lessonType=${gameType}`;
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  getUserwiseBasicVectoringGraph(day, gameName, userName, usageType, fromDate, toDate) {
    let url = `/analytics/basicVectoringLessonAnalyticsUsageGraph?${day}=${day}&lessonType=${gameName}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    if (day == "range") {
      url = `/analytics/basicVectoringLessonAnalyticsUsageGraph?fromDate=${fromDate}&toDate=${toDate}&lessonType=${gameName}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  downLoadLessonWiseRecords(day, gameName, userName, fromDate, toDate): Observable<Blob> {
    let url = `/analytics/downloadBasicVectoringLessonAnalyticsUsage?${day}=${day}&lessonType=${gameName}&selectedUserName=${userName}`;
    if (day == "range") {
      url = `/analytics/downloadBasicVectoringLessonAnalyticsUsage?fromDate=${fromDate}&toDate=${toDate}&lessonType=${gameName}&selectedUserName=${userName}`;
    }
    return this.http.get(this.apiUrl + url, { responseType: "blob" });
  }

  downLoadLessonWiseGraph(day, gameName, userName, usageType, fromDate, toDate): Observable<Blob> {
    let url = `/analytics/downloadBasicVectoringLessonAnalyticsUsageGraph?${day}=${day}&lessonType=${gameName}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    if (day == "range") {
      url = `/analytics/downloadBasicVectoringLessonAnalyticsUsageGraph?fromDate=${fromDate}&toDate=${toDate}&lessonType=${gameName}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    }
    return this.http.get(this.apiUrl + url, { responseType: "blob" });
  }
  // ***************SG-7145 end  *******************

  // ***************SG-7147 strat  *******************

  getLvelBasicVectoringGraph(day, gameName, userName, usageType, fromDate, toDate, levelType) {
    let url = `/analytics/basicVectoringLessonAnalyticsUsageGraph?${day}=${day}&lessonType=${gameName}&levelType=${levelType}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    if (day == "range") {
      url = `/analytics/basicVectoringLessonAnalyticsUsageGraph?fromDate=${fromDate}&toDate=${toDate}&lessonType=${gameName}&levelType=${levelType}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  getUserLevelWiseUserData(day, gameName, userName, fromDate, toDate, levelType) {
    let url = `/analytics/basicVectoringLessonAndLevelAnalyticsUsage?${day}=${day}&lessonType=${gameName}&levelType=${levelType}&selectedUserName=${userName}`;
    if (day == "range") {
      url = `/analytics/basicVectoringLessonAndLevelAnalyticsUsage?fromDate=${fromDate}&toDate=${toDate}&lessonType=${gameName}&levelType=${levelType}&selectedUserName=${userName}`;
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  downLoadLevelWiseBasicRecords(day, gameName, userName, fromDate, toDate, levelType): Observable<Blob> {
    let url = `/analytics/downloadBasicVectoringLessonAndLevelAnalyticsUsage?${day}=${day}&lessonType=${gameName}&levelType=${levelType}&selectedUserName=${userName}`;
    if (day == "range") {
      url = `/analytics/downloadBasicVectoringLessonAndLevelAnalyticsUsage?fromDate=${fromDate}&toDate=${toDate}&lessonType=${gameName}&levelType=${levelType}&selectedUserName=${userName}`;
    }
    return this.http.get(this.apiUrl + url, { responseType: "blob" });
  }

  downLoadLevelWiseBasicGraph(day, gameName, userName, usageType, fromDate, toDate, levelType): Observable<Blob> {
    let url = `/analytics/downloadBasicVectoringLessonAnalyticsUsageGraph?${day}=${day}&lessonType=${gameName}&levelType=${levelType}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    if (day == "range") {
      url = `/analytics/downloadBasicVectoringLessonAnalyticsUsageGraph?fromDate=${fromDate}&toDate=${toDate}&lessonType=${gameName}&levelType=${levelType}&selectedUserName=${userName}&selectedUsageType=${usageType}`;
    }
    return this.http.get(this.apiUrl + url, { responseType: "blob" });
  }
  // ***************SG-7147 end  *******************
}
// ***************SG-7046 start  *******************
